import React, { createContext, ReactNode, useContext, useState } from 'react';
import { xor } from 'lodash';

interface ContextProps {
	userIds: string[];
	showSelectCheckbox: boolean;
	resetUserIds: () => void;
	onToggleUser: (id: string) => void;
	startSelectingUsers: () => void;
	stopSelectingUsers: () => void;
}

interface ProviderProps {
	children: ReactNode;
}

export const SelectUsersContext = createContext<ContextProps>({
	userIds: [],
	showSelectCheckbox: false,
	resetUserIds: () => {},
	onToggleUser: () => {},
	startSelectingUsers: () => {},
	stopSelectingUsers: () => {},
});

export const useSelectUsersContext = () =>
	useContext<ContextProps>(SelectUsersContext);

export function SelectUsersContextProvider({ children }: ProviderProps) {
	const [userIds, setUserIds] = useState<string[]>([]);
	const [showSelectCheckbox, setShowSelectCheckbox] = useState(false);

	const onToggleUser = (id: string) => {
		setUserIds(xor(userIds, [id]));
	};

	const resetUserIds = () => {
		setUserIds([]);
	};

	const startSelectingUsers = () => {
		resetUserIds();
		setShowSelectCheckbox(true);
	};

	const stopSelectingUsers = () => {
		resetUserIds();
		setShowSelectCheckbox(false);
	};

	return (
		<SelectUsersContext.Provider
			value={{
				userIds,
				showSelectCheckbox,
				resetUserIds,
				onToggleUser,
				startSelectingUsers,
				stopSelectingUsers,
			}}>
			{children}
		</SelectUsersContext.Provider>
	);
}
